// 业务埋点日志上报
import { userInfo, routerule } from "../../global";
import ajax from "../ajax";
import Cookies from "js-cookie";

// 格式化时间为 yyyy-mm-dd hh:mm:ss:xxx 格式
function formatDateTime(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}:${milliseconds}`;
}

export function addLog(buttonId = '', buttonDesc = '', data = {}) {
  try {
    let addLogSwitch = localStorage.getItem('addLogSwitch') || 'off';
    if (addLogSwitch !== 'on') {
      console.log('埋点日志上报开关未开启，当前状态:', addLogSwitch);
      return;
    }
    console.log('userInfo111', userInfo);
    let commonParams = {
      broswerTime: formatDateTime(new Date()),
      url: location.href,
      buttonId: buttonId, // 具体操作Id
      buttonDesc: buttonDesc, // 具体操作Desc
      userAgent: navigator?.userAgent,
      ...userInfo
    }
    console.log('commonParams', commonParams);
    // 合并公共参数
    let params = {};
    Object.assign(params, commonParams);
    Object.assign(params, data);
    // 需要判断环境
    let urlArr = [];
    switch (window.APP_ENV) {
      case 'SG':
      case 'SG_GRAY':
        // 新加坡灰度
        urlArr = [
          '//us-api.jd.com/weblog/writeRemoteLog?LOP-DN=xjp.iwmslog.jd.com'
        ]
        break;
      case 'EU':
      case 'EU_GRAY':
        // 荷兰环境
        urlArr = [
          '//lop-proxy.ochama.com/weblog/writeRemoteLog?LOP-DN=hl.iwmslog.jd.com'
        ]
        break;
      case 'GG':
      case 'GG_GRAY':
        // 北美环境
        urlArr = [
          '//us-api.jd.com/weblog/writeRemoteLog?LOP-DN=gg.iwmslog.jd.com'
        ]
        break;
      default:
        urlArr = [
          '//uat-us-api.jd.com/weblog/writeRemoteLog?LOP-DN=uat.iwmslog.jd.com'
        ]
    }

    let urlIndex = 0;
    // 需要随机出来一个url
    let url = urlArr[urlIndex];
    urlIndex++;
    if (urlIndex >= urlArr.length) {
      urlIndex = 0;
    }
    console.log('url111', url);
    console.log('addLog', params);
    // let paramsStr = JSON.stringify(params).slice(0, 10000);
    let paramsStr = JSON.stringify(params);
    // 携带鉴权信息（与业务 soap 服务保持一致）
    let token = Cookies.get('lwms.sec.token');
    let userName = Cookies.get('userName');
    ajax({
      method: 'POST',
      url: url,
      contentType: 'application/json',
      headers: {
        'routerule': routerule?.value || '',
        'Authorization': token || '',
        'userName': userName ? encodeURIComponent(userName) : ''
      },
      data: { text: paramsStr },
      success: function (res) {
        console.log('埋点日志上报结果', res);
      },
      error: function (err) {
        console.error('埋点日志上报失败', err);
      }
    });
  } catch(err) {
    console.error('addLog err', err);
  }
}

function getAddlogSwitch () {
  try {
    let url = '';
    switch (window.APP_ENV) {
      case 'SG':
      case 'SG_GRAY':
        // 新加坡生产
        url = '//us-api.jd.com/weblog/writeRemoteLog?LOP-DN=xjp.iwmslogjsf.jd.com';
        break;
      case 'EU':
      case 'EU_GRAY':
        // 荷兰环境
        url = '//lop-proxy.ochama.com/weblog/writeRemoteLog?LOP-DN=hl.iwmslogjsf.jd.com';
        break;
      case 'GG':
      case 'GG_GRAY':
        // 北美环境
        url = '//us-api.jd.com/weblog/writeRemoteLog?LOP-DN=gg.iwmslogjsf.jd.com';
        break;
      default:
        url = '//uat-us-api.jd.com/weblog/writeRemoteLog?LOP-DN=uat.iwmslogjsf.jd.com';
    }
    // 请求开关接口
    // 携带鉴权信息（与业务 soap 服务保持一致）
    let token = Cookies.get('lwms.sec.token');
    let userName = Cookies.get('userName');
    ajax({
      method: 'GET',
      url: url,
      headers: {
        'routerule': routerule?.value || '',
        'Authorization': token || '',
        'userName': userName ? encodeURIComponent(userName) : ''
      },
      success: function (res) {
        console.log('getAddlogSwitch res', res);
        if (res?.data?.switch === 'on') {
          // 开启埋点日志上报
          localStorage.setItem('addLogSwitch', 'on');
        } else {
          // 关闭埋点日志上报
          console.log('关闭埋点日志上报');
          localStorage.setItem('addLogSwitch', 'off');
        }
      },
      error: function (err) {
        console.error('getAddlogSwitch error', err);
      }
    });
  } catch (err) {
    console.error('getAddlogSwitch err', err);
  }
}
// 防止多次初始化定时器
let addLogSwitchTimer = null;
function initAddLogSwitchTimer() {
  // 如果定时器已存在，先清除
  if (addLogSwitchTimer) {
    clearInterval(addLogSwitchTimer);
  }
  
  // 立即执行一次
  getAddlogSwitch();
  
  // 设置定时器（3分钟执行一次）
  addLogSwitchTimer = setInterval(() => {
    getAddlogSwitch();
  }, 180000);
}
// 只在浏览器环境且未初始化时执行
if (typeof window !== 'undefined' && !window.__addLogSwitchInitialized) {
  window.__addLogSwitchInitialized = true;
  initAddLogSwitchTimer();
}
